















































































import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { SelectWings, ScrollButton } from "wings-ui-components";
import PushApplicationsFilter from '@/components/Push/Applications/PushApplicationsFilter.vue';
import BaseItemsPage from '../BaseItemsPage';
import { PartnerApplicationItem } from '@/store/push/application/types';


@Component({components:{PushApplicationsFilter, ScrollButton, SelectWings}})
export default class PushApplications extends BaseItemsPage<PartnerApplicationItem> {
  @Getter("pushApplications") pushApplicationsResponse: any;
  private is_show_filter = false;
  currentSort= "id";
  currentSortOrder= "desc";
  tableFields = [
    'id',
    'name',
    'description',
  ];

  getData(): any {
    return this.pushApplicationsResponse;
  }
}
